import {
	AfterContentChecked,
	ChangeDetectorRef,
	Component,
	Input
} from '@angular/core';
import { DateFormatService } from '../../services';
import { CartaPorteView } from 'src/app/modules/traceability/consult-traceability/view-waybill-traceability/view-waybill-traceability.component';
import { WaybillService } from 'src/app/modules/traceability/services/waybill.service';

@Component({
	selector: 'app-nested-view',
	templateUrl: './nested-view.component.html',
	styleUrls: ['./nested-view.component.scss']
})
export class NestedViewComponent implements AfterContentChecked {
	@Input() node: NodeModel;

	constructor(
		private cartaPorteService: WaybillService,
		private cdref: ChangeDetectorRef,
		private dateFormatService: DateFormatService
	) {}

	ngAfterContentChecked(): void {
		this.cdref.detectChanges();
	}

	loadChildren(node: any) {
		this.cartaPorteService.getTraza(node.numeroCTG).subscribe(data => {
			data.forEach(d => {
				const child: NodeModel = {} as NodeModel;
				child.numeroCTG = d.numeroCTG;
				child.cartaPorte = d;
				child.cartaPorte.fechaMovimiento =
					this.dateFormatService.convertUtcToLocalFormattedWithTime(
						new Date(d.fechaMovimiento)
					);
				child.children = [];
				node.children.push(child);
			});
			node.isExpanded = true;
		});
	}

	toggleChildren(node: any) {
		if (node.children.length == 0) {
			this.loadChildren(node);
		} else {
			node.isExpanded = !node.isExpanded;
		}
	}
}

export interface NodeModel {
	numeroCTG: string;
	cartaPorte: CartaPorteView;
	children?: NodeModel[];
	isExpanded: boolean;
}
